export enum ClientDashboardCardProps {
  HEADING = 'Total CO\u2082e Of All Products',
  EMPTY_CO2E_AMOUNT = '0.00',
  CO = 'kgCO',
  KG_CARBON_EMISSION = 'kgCO\u2082e',
  SET_GOAL_LABEL = 'Set goal',
  EDIT_GOAL_LABEL = 'Edit',
  SET_GOAL = 'Set',
  GIRL_ILLUSTRATION_ALT = 'girl',
  SUBSCRIPT = '2',
  POST_SUBSCRIPT = 'e',
  HEADING_COMPANY = 'Total CO\u2082e of Company',
  MAN_ILLUSTRATION_ALT = 'man',
}
